import { render, staticRenderFns } from "./WorldCupPredictor.vue?vue&type=template&id=7a223913&scoped=true&"
import script from "./WorldCupPredictor.vue?vue&type=script&lang=js&"
export * from "./WorldCupPredictor.vue?vue&type=script&lang=js&"
import style0 from "./WorldCupPredictor.vue?vue&type=style&index=0&id=7a223913&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a223913",
  null
  
)

export default component.exports